






















































































import Vue from 'vue';
import PracticeBubble from '@/components/PracticeBubble.vue';
import SearchBar from '@/components/SearchBar.vue';
import UserIcon from '@/components/UserIcon.vue';

export default Vue.extend({
  name: 'Community',
  components: {
    PracticeBubble,
    SearchBar,
    UserIcon,
  },
  data() {
    return {
      bestPractices: [],
      bestTeachers: [],
      featuredTeacher: {
        name: '',
        username: '',
      },
      newestPractices: [],
    };
  },
  created() {
    // Reassign this scope for callback usage
    const component = this;

    fetch('https://api.pocketyoga.com/features/teacher', {
      headers: { version: '5' },
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return response.json();
      })
      .then((featured) => {
        component.featuredTeacher.name = featured.title;

        fetch(`https://api.pocketyoga.com/profiles/${featured.related_id}`, {
          headers: { version: '5' },
        })
          .then((response) => {
            if (!response.ok) {
              throw response;
            }

            return response.json();
          })
          .then((json) => {
            component.featuredTeacher.username = json.username;
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });

    fetch('https://api.pocketyoga.com/charts/6', {
      headers: { version: '5' },
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return response.json();
      })
      .then((json) => {
        component.bestPractices = json.best_practices;
        component.bestTeachers = json.best_teachers;
        component.newestPractices = json.newest_practices;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    onSearchChange(search: string) {
      if (search !== null) {
        this.$router.push({
          name: 'search',
          query: {
            s: search,
          },
        });
      }
    },
  },
});
